import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  getPlantillaVolverAContactar,
  guardarPlantillaVolverAContactar,
  mensajeDeError,
} from '../../../services/volverAContactarService';

const VARIABLES = ['{nombre}', '{tramite}'];

const ejemplo = (texto) => (texto || '')
  .replace(/\{nombre\}/g, 'Juan')
  .replace(/\{tramite\}/g, 'tu jubilación');

/**
 * La plantilla del aviso del listado "Volver a contactar" (V261). Se guarda en el sistema (no en el
 * servicio de WhatsApp), igual que las de citación. El texto tiene que dejar claro que el número es
 * solo de avisos: no hay nadie leyendo las respuestas ni un bot que saque turnos.
 */
export default function PlantillaVolverAContactar() {
  const [plantilla, setPlantilla] = useState(null);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    getPlantillaVolverAContactar()
      .then(setPlantilla)
      .catch(() => setPlantilla(''));
  }, []);

  const guardar = async () => {
    setGuardando(true);
    try {
      setPlantilla(await guardarPlantillaVolverAContactar(plantilla));
      toast.success('Plantilla de "Volver a contactar" guardada.');
    } catch (err) {
      toast.error(err.response?.status === 403
        ? 'No tenés permiso para cambiar las plantillas.'
        : mensajeDeError(err, 'No se pudo guardar.'));
    } finally {
      setGuardando(false);
    }
  };

  if (plantilla === null) return null;
  return (
    <div className="card shadow-sm border-0 rounded-4 p-4" style={{ gridColumn: '1 / -1' }}>
      <h5 className="fw-semibold mb-1"><i className="bi bi-telephone-outbound me-2" />Aviso de "Volver a contactar"</h5>
      <p className="text-muted small mb-3">
        Es el mensaje del botón "Avisar" del listado. El operador lo ve y lo puede corregir antes de mandarlo.
        Aclarale a la persona que este número es solo de avisos. Variables:{' '}
        {VARIABLES.map((v) => <code key={v} className="me-2">{v}</code>)}
      </p>
      <textarea
        className="form-control" rows={5} value={plantilla} maxLength={1000}
        onChange={(e) => setPlantilla(e.target.value)}
      />
      <div className="small mt-1" style={{ color: '#374151', whiteSpace: 'pre-line' }}>
        <strong>Ejemplo:</strong> {ejemplo(plantilla)}
      </div>
      <div className="mt-3">
        <button type="button" className="btn btn-primary" disabled={guardando || !plantilla.trim()} onClick={guardar}>
          {guardando ? 'Guardando…' : 'Guardar plantilla'}
        </button>
      </div>
    </div>
  );
}
